import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAgents = async () => {
  const res = await axios.get(`${API_BASE_URL}/agents`);
  return res.data;
};

export const rechargeAgent = async (phone, amount) => {
  const res = await axios.post(`${API_BASE_URL}/agents/recharge`, { phone, amount });
  return res.data;
};

export const getPerformance = async (number) => {
  const res = await axios.get(`${API_BASE_URL}/agents/performance/${number}`);
  return res.data;
};

export const addAgent = async (agent) => {
  const res = await axios.post(`${API_BASE_URL}/agents`, agent);
  return res.data;
};

export const editAgent = async (number, agent) => {
  const res = await axios.put(`${API_BASE_URL}/agents/${number}`, agent);
  return res.data;
};

export const deleteAgent = async (number) => {
  const res = await axios.delete(`${API_BASE_URL}/agents/${number}`);
  return res.data;
};

export const getBets = async (filters) => {
  const params = new URLSearchParams(filters).toString();
  const res = await axios.get(`${API_BASE_URL}/bets?${params}`);
  return res.data;
};

export const updateBet = async (betId, update) => {
  const res = await axios.put(`${API_BASE_URL}/bets/${betId}`, update);
  return res.data;
};

export const saveDrawSettings = async (settings) => {
  const res = await axios.post(`${API_BASE_URL}/draw-results`, settings);
  return res.data;
};

export const getWinners = async () => {
  const res = await axios.get(`${API_BASE_URL}/winner`);
  return res.data;
};

export const lockDrawWinners = async (drawId, lockedWinners) => {
  const res = await axios.post(`${API_BASE_URL}/draw-results/lock`, {
    draw_id: drawId,
    locked_winners: lockedWinners
  });
  return res.data;
};

export const finalizeDraw = async (drawId, prizeTiers) => {
  const res = await axios.post(`${API_BASE_URL}/draw-results/finalize`, {
    draw_id: drawId,
    prize_tiers: prizeTiers
  });
  return res.data;
};

export const getDrawResults = async (drawId) => {
  const res = await axios.get(`${API_BASE_URL}/draw-results/${drawId}`);
  return res.data;
};

export const triggerDraw = async (drawId, prizeTiers) => {
  const res = await axios.post(`${API_BASE_URL}/draw-results/trigger`, {
    draw_id: drawId,
    prize_tiers: prizeTiers
  });
  return res.data;
};